/**
 * Static-translations for ar. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const ar = {
  'anon.heading_default': 'متابعة كضيف',
  'anon.try_again': 'حاول مرة أخرى',
  'auth.back_to_login': 'العودة إلى تسجيل الدخول',
  'auth.check_email_message': 'تحقق من بريدك الإلكتروني للحصول على رمز التأكيد.',
  'auth.check_email_title': 'تحقق من بريدك الإلكتروني',
  'auth.confirm_email_title': 'تأكيد بريدك الإلكتروني',
  'auth.confirmation_code': 'رمز التأكيد',
  'auth.continue_with_apple': 'المتابعة مع Apple',
  'auth.continue_with_facebook': 'متابعة مع Facebook',
  'auth.continue_with_github': 'متابعة مع GitHub',
  'auth.continue_with_google': 'المتابعة مع Google',
  'auth.create_account': 'إنشاء حساب',
  'auth.default_subtitle': 'سجّل الدخول للوصول إلى جميع الميزات ومزامنة بياناتك.',
  'auth.email': 'عنوان البريد الإلكتروني',
  'auth.email_already_registered': 'هذا البريد الإلكتروني مسجّل بالفعل. سجّل الدخول أدناه بكلمة المرور أو بالحساب الذي استخدمته للتسجيل.',
  'auth.email_exists': 'يوجد حساب بهذا البريد الإلكتروني بالفعل.',
  'auth.email_not_confirmed': 'يرجى تأكيد بريدك الإلكتروني أولاً.',
  'auth.forgot_password': 'هل نسيت كلمة المرور؟',
  'auth.forgot_password_title': 'هل نسيت كلمة المرور؟',
  'auth.forgot_subtitle': 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة تعيين كلمة المرور.',
  'auth.generic_error': 'حدث خطأ ما',
  'auth.have_account': 'لديك حساب؟',
  'auth.hide_password': 'إخفاء كلمة المرور',
  'auth.identity_already_linked': 'هذا الحساب مسجّل بالفعل. سجّل الدخول به أدناه.',
  'auth.invalid_credentials': 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
  'auth.invalid_otp': 'الرمز غير صالح أو منتهي الصلاحية.',
  'auth.last_used': 'آخر استخدام · {email}',
  'auth.last_used_no_email': 'آخر استخدام',
  'auth.link_purchase_subheading': 'سنربط الشراء بحسابك للحفاظ على الوصول.',
  'auth.log_in': 'تسجيل الدخول',
  'auth.log_in_link': 'تسجيل الدخول',
  'auth.login_continue_purchase': 'سجّل الدخول لمتابعة عملية الشراء',
  'auth.network_error': 'خطأ في الشبكة. تحقق من اتصالك وحاول مرة أخرى.',
  'auth.no_account': 'ليس لديك حساب؟',
  'auth.or': 'أو',
  'auth.password': 'كلمة المرور',
  'auth.passwords_mismatch': 'كلمتا المرور غير متطابقتين',
  'auth.rate_limited': 'طلبات كثيرة جدًا. حاول مرة أخرى لاحقًا.',
  'auth.repeat_password': 'كرّر كلمة المرور',
  'auth.reset_link_valid': 'الرابط صالح لمدة ساعة واحدة.',
  'auth.reset_password_title': 'إعادة تعيين كلمة المرور',
  'auth.reset_sent_message': 'إذا كان هذا البريد موجودًا، فقد تم إرسال رمز إعادة التعيين.',
  'auth.reset_sent_subtitle': 'أرسلنا رابط إعادة تعيين كلمة المرور. اتبع التعليمات في البريد الإلكتروني.',
  'auth.restore_purchases_heading': 'استعادة المشتريات',
  'auth.restore_purchases_subheading': 'يُرجى تسجيل الدخول لاستعادة مشترياتك.',
  'auth.send_reset': 'إرسال بريد إعادة التعيين',
  'auth.service_unavailable': 'الخدمة غير متاحة مؤقتًا. حاول لاحقًا.',
  'auth.show_password': 'إظهار كلمة المرور',
  'auth.sign_out': 'تسجيل الخروج',
  'auth.sign_up': 'إنشاء حساب',
  'auth.sign_up_link': 'إنشاء حساب',
  'auth.signed_in': 'تم تسجيل الدخول',
  'auth.signin_failed': 'فشل تسجيل الدخول',
  'auth.signup_failed': 'فشل التسجيل',
  'auth.verify': 'تأكيد',
  'auth.weak_password': 'كلمة المرور ضعيفة جدًا.',
  'auth.welcome': 'مرحباً!',
  'auth.welcome_signup': 'مرحبًا!',
  'countdown.d': 'ي',
  'countdown.h': 'س',
  'countdown.m': 'د',
  'countdown.s': 'ث',
  'cta.close': 'إغلاق',
  'cta.continue': 'متابعة',
  'cta.get_lifetime_access': 'احصل على وصول مدى الحياة',
  'cta.get_plan_daily': 'احصل على الخطة اليومية',
  'cta.get_plan_monthly': 'احصل على الخطة الشهرية',
  'cta.get_plan_weekly': 'احصل على الخطة الأسبوعية',
  'cta.get_plan_yearly': 'احصل على الخطة السنوية',
  'cta.start_trial': 'ابدأ تجربة مجانية لمدة {days} يوم',
  'modal.close_aria': 'إغلاق',
  'modal.continue': 'متابعة',
  'modal.error_generic': 'حدث خطأ ما',
  'modal.loading': 'جارٍ التحميل…',
  'modal.purchase_restored_subtitle': 'كل شيء جاهز — استمتع!',
  'modal.purchase_restored_title': 'مرحبًا بعودتك',
  'modal.purchase_success_subtitle': 'كل شيء جاهز — استمتع!',
  'modal.purchase_success_title': 'تم استلام الدفع',
  'modal.verifying_subscription': 'جارٍ التحقق من اشتراكك…',
  'nav.back': '→ رجوع',
  'nav.back_aria': 'رجوع',
  'offer.limited_time': 'عرض لفترة محدودة',
  'payment.awaiting_title': 'أكمل الدفع في علامة التبويب الجديدة',
  'payment.checking': 'جارٍ التحقق…',
  'payment.ive_paid': 'لقد دفعت',
  'payment.open_checkout_again': 'افتح الدفع مرة أخرى',
  'payment.open_checkout_button': 'افتح الدفع',
  'pricing.free_trial_days': 'تجربة مجانية لمدة {days} يومًا',
  'pricing.included_per': 'متضمن لكل {interval}:',
  'pricing.interval.day': 'يوم',
  'pricing.interval.lifetime_short': 'مدى الحياة',
  'pricing.interval.month': 'شهر',
  'pricing.interval.period': 'فترة',
  'pricing.interval.week': 'أسبوع',
  'pricing.interval.year': 'سنة',
  'pricing.money_back': 'ضمان استرداد الأموال لمدة 30 يومًا',
  'pricing.most_popular': 'الأكثر شعبية',
  'pricing.no_prices': 'لا توجد أسعار متاحة.',
  'pricing.plan_label.daily': 'الخطة اليومية',
  'pricing.plan_label.lifetime': 'مدى الحياة',
  'pricing.plan_label.monthly': 'خطة شهرية',
  'pricing.plan_label.weekly': 'خطة أسبوعية',
  'pricing.plan_label.yearly': 'خطة سنوية',
  'pricing.plans_aria': 'الخطط',
  'session.contact_support': 'اتصل بالدعم',
  'session.restore_purchases': 'استعادة المشتريات',
  'session.sign_out': 'تسجيل الخروج',
  'session.signed_in_as_prefix': 'تم تسجيل الدخول باسم',
  'session.signing_out': 'جارٍ تسجيل الخروج…',
  'support.attachments_label': 'المرفقات',
  'support.close_button': 'إغلاق',
  'support.done_button': 'تم',
  'support.email_placeholder': 'أدخل بريدك الإلكتروني',
  'support.heading': 'الدعم',
  'support.instruction': 'يُرجى ملء النموذج أدناه لإرسال طلب الدعم.',
  'support.invalid_email': 'بريد إلكتروني غير صالح',
  'support.message_length': '1-5000 حرفاً',
  'support.message_placeholder': 'أدخل رسالتك',
  'support.required': 'مطلوب',
  'support.send_another': 'إرسال طلب آخر',
  'support.send_button': 'إرسال',
  'support.sending': 'جارٍ الإرسال…',
  'support.subject_length': '3-200 حرفاً',
  'support.subject_placeholder': 'أدخل الموضوع',
  'support.success_heading': 'تم إرسال الطلب',
  'support.success_message_prefix': 'لقد تلقينا رسالتك وسنرد على'
} as const;

export default ar;
